// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__142Zc","error":"Textarea_error__1Qsxb","readonly":"Textarea_readonly__3mS6K","disabled":"Textarea_disabled__cPIUw"};